'use strict';

angular
  .module('ClinicApp')
  .factory('RescheduledAppointmentSlotsService', function(RescheduledAppointmentSlotsResource, $http, ClinicConfig) {
    return {
      getRescheduledAppointmentSlotOptions: function(appointmentId) {
        return RescheduledAppointmentSlotsResource.query({
          appointmentId: appointmentId,
        }).$promise;
      },

      setRescheduledAppointmentSlotOptions: function(appointmentId, data) {
        return $http.post(ClinicConfig.HOSTNAME + '/clinic/appointment/' + appointmentId + '/rescheduledAppointmentSlotOptions', data).then(function(response) {
          return response.data;
        });
      },
    };
  });
